export default __webpack_public_path__ + "static/media/Affiliate.0c670113.jpg";